import React from 'react';
import styled from 'styled-components';

import renketsu from '../../components/atoms/data/renketsu-icon.svg';
import douka from '../../components/atoms/data/douka-icon.svg';
import datsuraku from '../../components/atoms/data/datsuraku-icon.svg';
import ragyoka from '../../components/atoms/data/ragyoka-icon.svg';
import jakkei from '../../components/atoms/data/jakkei-icon.svg';

const HelpDialogChangeRenketsu = (props) => {
    return(
        <React.Fragment>
            <p align="center"><b>連結</b></p>
            単語同士がつながって発音されること。<br />
            <br />
            ●単語の最後の子音と、次の単語の最初の母音がつながって発音される。<br />
            <div>ta<Blue>ke o</Blue>n → テイコン</div>
            <div>a<Blue>n u</Blue>mbrella → アナンブレラ</div>
            <div>fa<Blue>r a</Blue>way → ファーラウェイ</div>
            <br />
            <div><Border>スクリプト上の表記</Border></div>
            <VoiceChange>
                <div>take on  連結する二つの音の下にマーク</div>
                <Renketsu><img src={renketsu} alt="img" width="25px" height="18px" /></Renketsu>
            </VoiceChange>
            <br />
            ※発音を便宜上カタカナで表記していますが、厳密には日本語とは異なる発音となりますので注意してください。
        </React.Fragment>
    );
}

const HelpDialogChangeDouka = (props) => {
    return(
        <React.Fragment>
            <p align="center"><b>同化</b></p>
            隣り合う音に影響を受けて、違う音に変化すること。<br />
            <br />
            ●単語の最後の子音と、次のyの音が同化する。
            <div>ge<Blue>t y</Blue>our car → ゲッチュアカー</div>
            <div>pla<Blue>ce y</Blue>our order → プレイシュアオーダー</div>
            <br />
            <div><Border>スクリプト上の表記</Border></div>
            <VoiceChange>
                <div>ge<b><Red>(</Red></b>t your<b><Red>)</Red></b> car　同化する音を( )で囲む</div>
            </VoiceChange>
            <br />
            ※発音を便宜上カタカナで表記していますが、厳密には日本語とは異なる発音となりますので注意してください。
        </React.Fragment>
    );
}

const HelpDialogChangedatsuraku = (props) => {
    return(
        <React.Fragment>
            <p align="center"><b>脱落</b></p>
            あるべき音が発音されない、あるいは聞こえにくくなること。<br />
            <br />
            ●破裂音*が語末にくると脱落する。
            <div>that’s righ<Blue>t</Blue> → ザッツライッ</div>
            <div>on to<Blue>p</Blue> → オントッ</div>
            <div><Font13>*破裂音とは/p/, /t/, /k/, /b/, /d/, /g/ の音のこと</Font13></div>
            <br />
            ●子音+子音で前にくる子音が脱落する。　　　　　　
            <div>ge<Blue>t</Blue> tired → ゲッタイアド</div>
            <div>cu<Blue>t</Blue> this → カッディス</div>
            <br />
            ●子音と子音の間にくる/t/ /k/ /d/が脱落する。
            <div>perfec<Blue>t</Blue>ly → パーフェクリー</div>
            <div>inves<Blue>t</Blue>ment → インヴェスメント</div>
            <br />
            ●/nt/の連続で、/t/が/n/の音にひっぱられて同じような音になる、あるいは/t/が脱落する。<br />
            <div>plen<Blue>t</Blue>y → プレンニー　プレニー</div>
            <br />
            <div><Border>スクリプト上の表記</Border></div>
            <VoiceChange>
            <div>perfectly　<Font13>脱落する音の上に斜線</Font13></div>
                <Datsuraku><img src={datsuraku} alt="img" width="12px" height="12px" /></Datsuraku>
            </VoiceChange>
            <br />
            ※発音を便宜上カタカナで表記していますが、厳密には日本語とは異なる発音となりますので注意してください。
        </React.Fragment>
    );
}

const HelpDialogChangeragyoka = (props) => {
    return(
        <React.Fragment>
            <p align="center"><b>「ら行」化</b></p>
            /t/や/d/が日本語の「ら行」に近い音（はじき音）になる。（専門的には「はじき音」化）<br />
            <br />
            ●/t/ /d/が母音に挟まれると日本語のら行に近い音になる。<br />
            <div>l<Blue>et i</Blue>t go → レリゴー</div>
            <div>w<Blue>ate</Blue>r → ウォーラー</div>
            <br />
            ●/t/ /d/が母音と/l/に挟まれると日本語のら行に近い音になる。
            <div>t<Blue>itl</Blue>e → タイロー</div>
            <div>l<Blue>ittl</Blue>e → リロー</div>
            <br />
            <div><Border>スクリプト上の表記</Border></div>
            <VoiceChange>
                <div>water　「ら行」化する音を○で囲む</div>
                <Ragyoka><img src={ragyoka} alt="img" width="10px" height="24px" /></Ragyoka>
            </VoiceChange>
            <br />
            ※発音を便宜上カタカナで表記していますが、厳密には日本語とは異なる発音となりますので注意してください。
        </React.Fragment>
    );
}

const HelpDialogChangejakkei = (props) => {
    return(
        <React.Fragment>
            <p align="center"><b>弱形</b></p>
            人称代名詞、前置詞、be動詞、助動詞などは強形（strong form）と弱形（weak form）という2通りの発音を持っている。文中で特に強調される場合以外は、通常、弱形の発音で発音される。辞書にも2通りの表記があるので、注意して見てみましょう。<br />
            <br />
            your → ヨ<br />
            of → ゥヴ<br />
            <br />
            <div><Border>スクリプト上の表記</Border></div>
            <VoiceChange>
                <div>your　弱形になっている音の上に△</div>
                <Jakkei><img src={jakkei} alt="img" width="25px" height="25px" /></Jakkei>
            </VoiceChange>
            <br />
            ※発音を便宜上カタカナで表記していますが、厳密には日本語とは異なる発音となりますので注意してください。<br />
        </React.Fragment>
    );
}
export { HelpDialogChangeRenketsu, HelpDialogChangeDouka, HelpDialogChangedatsuraku, HelpDialogChangeragyoka, HelpDialogChangejakkei };

const Blue = styled.span`
    color: #0077ff;
`;

const Red = styled.span`
    color: #FF0000;
`;

const Font13 = styled.span`
    font-size: 13px;
`;

const Border = styled.span`
    text-decoration:underline;
`;

const VoiceChange = styled.div`
    width: 90%
    position: relative;
    font-family: sans-serif;
    font-size: 14px;
`;

const Renketsu = styled.div`
    position: absolute;
    top: 10px;
    left: 19px;
`;
const Datsuraku = styled.div`
    position: absolute;
    top: 2px;
    left: 39px;
`;
const Ragyoka = styled.div`
    position: absolute;
    top: -2px;
    left: 17px;
`;
const Jakkei = styled.div`
    position: absolute;
    top: -3px;
    left: 2px;
`;
